function deepAssign(source){
    if(Array.isArray(source)){
        let dest = [];

        for(let i = 0; i < source.length; i++){
            dest[i] = deepAssign(source[i]);
        }

        return dest;
    }

    if(typeof source === "object" && source){
        let dest = Object.assign({}, source);

        for(let property in source){
            if(source.hasOwnProperty(property)){
                dest[property] = deepAssign(source[property]);
            }
        }

        return dest;
    }

    return source;
}

function today(){
    let date = new Date(Date.now());

    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();

    return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
}

function addDays(date, days){
    date.setDate(date.getDate() + days);
}

function stripTimeFromDateString(dateString){
    let date = new Date(dateString);

    let day = date.getDate() + "";
    if(day.length == 1){
        day = "0" + day;
    }
    let month = (date.getMonth() + 1) + "";
    if(month.length == 1){
        month = "0" + month;
    }
    let year = date.getFullYear();

    return year + "-" + month + "-" + day;
}

function sortByName(a, b){
    if (a.Name < b.Name) {
        return -1;
    }
    else if (a.Name > b.Name) {
        return 1;
    }

    return 0;
}

export default {
    deepAssign: deepAssign,
    today,
    addDays,
    stripTimeFromDateString,
    sortByName
};
